<!--
 * @Descripttion: 收藏页文章组件
 * @Author: Niu Chenxin
 * @Date: 2021-01-14 10:58:37
 * @LastEditors: taoyan taoyan_work@163.com
 * @LastEditTime: 2022-10-21 17:10:04
-->
<template>
  <div class="list_item_article">
    <van-list
      :class="
        userArticeCollect.length == 0 ? 'list_wrap' : 'list_wrap list_empty'
      "
      v-model="acticeParams.Loading"
      :finished="acticeParams.Finished"
      :finished-text="acticeParams.finishText"
      :error.sync="acticeParams.Error"
      error-text="请求失败，点击重新加载"
      @load="getArticle"
    >
      <div
        class="list_item"
        v-for="(item, index) in userArticeCollect"
        :key="item.contentId"
        @click.stop="gioClick(item, index)"
      >
        <router-link
          v-if="item"
          :to="{ name: 'communityDetail', params: { id: item.contentId } }"
          :data="JSON.stringify(item)"
        >
          <div class="item_left">
            <div class="item_title">
              <span
                class="item_classify"
                v-if="item.tagName != '' && item.tagName != null"
                >{{ item.tagName }}</span
              >
              {{ item.content }}
            </div>
            <div class="item_read_collection">
              <span class="item_read"
                >{{ fomatterNum(item.watchNum) }}妈妈看过</span
              >
              <span class="item_collection"
                >{{ fomatterNum(item.collectNum) }}收藏</span
              >
            </div>
          </div>
          <div class="item_right" v-lazy:background-image="item.coverUrl"></div>
        </router-link>
      </div>
    </van-list>
  </div>
</template>

<script>
import {
  BuiedPointClick_Fn,
  Exposurer_babyList_Fn,
} from '@/assets/js/BuriedPointEvent'
import API from '@/utils/axiosApi/zeroShoppingApi.js'
export default {
  props: {
    fomatterNum: {
      type: Function,
    },
    getCookie: {
      type: Function,
    },
  },
  data() {
    return {
      acticeParams: {
        page: 1,
        size: 25,
        Loading: false, // 是否加载状态
        Finished: false, // 是否加载完成
        Error: false, // 是否加载失败
        finishText: '', // 加载完成文本
      },
      userArticeCollect: [],
      itemSetId: '',
      sceneId: '',
      requestId: '',
    }
  },
  mounted() {
    var date = Date.parse(new Date())
    var id = this.getCookie('xmh_unionid')
    this.requestId = this.$md5(date + id)
    if (this.$http.hostName == 'https://mom.feihe.com') {
      // 正式环境物料id和服务id
      this.itemSetId = '16'
      this.sceneId = '41'
    } else {
      // uat环境物料id和服务id
      this.itemSetId = '12'
      this.sceneId = '296'
    }
  },
  methods: {
    getArticle: function() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const that = this
      API.getInvitationList(
        {
          crmId: userInfo.crm_id,
          // crmId: '1234567890',
          pageNum: this.acticeParams.page,
          pageSize: this.acticeParams.size,
        },
        (res) => {
          this.acticeParams.Loading = false
          if (res.code == '200') {
            this.userArticeCollect = this.userArticeCollect.concat(
              res.data.data
            )
            console.warn('res列表请求结果:', res.data)

            this.$nextTick(() => {
              Exposurer_babyList_Fn.observe('NewsShown', '.list_item', false)
            })

            if (
              that.acticeParams.page >=
              Math.ceil(res.data.total / that.acticeParams.size)
            ) {
              this.acticeParams.Finished = true
              this.acticeParams.finishText = '——已经到底了哦——'
            } else {
              this.acticeParams.page += 1
            }
            if (this.acticeParams.page == 1 && res.data.data.length == 0) {
              this.acticeParams.finishText = ''
              this.$emit('isEmpty', true)
              $('.van-tabs__content').css('background', '#fff')
            }
          } else {
            console.log('列表刷新错误')
            this.acticeParams.Loading = false
            this.acticeParams.Error = true
          }
        },
        (res) => {
          this.acticeParams.Loading = false
          this.acticeParams.Error = true
        }
      )
    },
    initFn() {
      this.acticeParams.Finished = false
      this.acticeParams.Error = false
      this.acticeParams.Loading = false
      this.userArticeCollect = []
      this.acticeParams.page = 1
    },
    gioClick(item, index) {
      // this.$router.push({
      //   path: '/communityIndex/communityDetail',
      //   query: { id: item.contentId },
      // })

      // location.replace(`/communityIndex/communityDetail/${item.contentId}`)
      console.warn(item, '跳转详情', location.href)
      BuiedPointClick_Fn('NewsClick', {
        xmhh5_articletitle_view_pagename: this.$route.meta.title,
        xmhh5_article_title: item.title,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.list_item_article {
  .list_wrap {
    background: #ffffff;
    .list_item {
      height: 120px;
      background: #ffffff;
      border-bottom: 1px solid @expertBorderColor242;
      overflow: hidden;
      position: relative;
      .item_left {
        float: left;
        padding: 16px 121px 17px 0;
        .item_title {
          font-size: @indexFontSize14;
          color: @expertFontColor51;
          line-height: 1.57em;
          height: 3.14em;
          overflow: hidden;
          margin-bottom: 30px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          .item_classify {
            font-size: @indexFontSize12;
            border-radius: 2px;
            padding: 0px 3px;
            height: 1.3em;
            line-height: 1.3em;
            color: #ff67c1;
            border: 1px solid #ff67c1;
            display: inline-block;
            box-sizing: border-box;
            margin-right: 5px;
          }
        }
        .item_read_collection {
          color: #999999;
          font-size: @indexFontSize12;
          .item_read {
            margin-right: 8px;
          }
        }
      }
      .item_right {
        width: 108px;
        height: 85px;
        background: #eee;
        float: left;
        background-size: auto 100%;
        background-position: center center;
        position: absolute;
        right: 0;
        top: 14px;
        border-radius: 4px;
      }
    }
    /deep/.van-list__loading {
      background: @expertFontColor255;
    }
    /deep/.van-list__finished-text {
      background: @expertFontColor255;
    }
    /deep/.van-list__placeholder {
      background: @expertFontColor255;
    }
    /deep/.van-list__error-text {
      background: @expertFontColor255;
    }
  }
  .list_empty {
    padding: 0 12px;
  }
}
</style>
